import React from "react";
import HeroBadge from "./HeroBadge";
import HeroTitle from "./HeroTitle";
import HeroDescription from "./HeroDescription";
import KeyHighlights from "./KeyHighlights";

const HeroContent = () => {
  return (
    <div className="flex-1 lg:pr-8 text-center lg:text-left min-w-0 overflow-hidden">
      <div className="min-w-0">
        <HeroBadge />
        <HeroTitle />
        <HeroDescription />

        <KeyHighlights />
      </div>
    </div>
  );
};

export default HeroContent;
